import { CommonUserInfo } from './commonuserinfo';

export class ReferFriendRequest {
    public sessionToken: string = '';
    public commonUserInfo: CommonUserInfo = new CommonUserInfo();
    public friendList: CommonUserInfo[] = [];
    public companyCode: string ='';
    public jobPostingId: number = 0;
    public referralType: string = '';
    public referralCode: string = '';
    public utmTrackerId!: number;
    public sourceChannelValue:string='Talent Portal';
}
